export default __webpack_public_path__ + "static/media/month.88bc513a.svg";